import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import SubOrganizationsAPI from '../../../../utils/api/subOrganizationsAPI';

const entity = new ReduxRestEntity({
  name: 'settings',
  api: SubOrganizationsAPI(),
});

export default entity;
